import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Snackbar,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WithCsp from './WithCsp';
import WithoutCsp from './WithoutCsp';
import SearchFilter from './SearchFilter';
import { WithCspBrand, WithoutCspBrand } from '../../../../../API/Branding';
import { fetchStates } from 'API/AgentOnboarding/api';
import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StatCard from './StatCard';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box mt={1}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
const Index = () => {
  const [value, setValue] = useState(0);
  const [IsLoading, setIsLoading] = useState(false);
  const [Error, setError] = useState(false);
  const [CspBrand, setCspBrand] = useState([]);
  const [WithouCspBrand, setWithouCspBrand] = useState([]);
  const [page, setPage] = useState(0); // Current page (starts from 0)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [TotalCount, setTotalCount] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const [filter, setFilter] = useState({
    search: '',
    retail_state: '',
    retail_district: '',
    user_type: ''
  });
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleClear = () => {
    setFilter({ search: '', retail_state: '', retail_district: '', user_type: '' });
  };
  const [pagew, setPagew] = useState(0); // Current page (starts from 0)
  const [rowsPerPagew, setRowsPerPagew] = useState(5); // Rows per page
  const [TotalCountw, setTotalCountw] = useState(0);
  const [State, setState] = useState('');
  const [NoWithBrand, setNoWithBrand] = useState(null);
  const [NoWithoutBrand, setNoWithoutBrand] = useState(null);

  useEffect(() => {
    if (value === 0) {
      setCspBrand([]);
      WithCspBrand(page + 1, rowsPerPage, filter, setIsLoading, setCspBrand, setError, setTotalCount, setNoWithoutBrand, setNoWithBrand);
    }
  }, [value, filter.search, filter.retail_state, filter.retail_district, page, rowsPerPage]);

  const refunctionwithOut = () => {
    setWithouCspBrand([]);
    WithoutCspBrand(pagew + 1, rowsPerPagew, filter, setIsLoading, setWithouCspBrand, setError, setTotalCountw);
  };
  const refunctionwith = () => {
    setCspBrand([]);
    WithCspBrand(page + 1, rowsPerPage, filter, setIsLoading, setCspBrand, setError, setTotalCount, setNoWithoutBrand, setNoWithBrand);
  };
  useEffect(() => {
    if (value === 1) {
      setWithouCspBrand([]);
      WithoutCspBrand(pagew + 1, rowsPerPagew, filter, setIsLoading, setWithouCspBrand, setError, setTotalCountw);
    }
  }, [value, filter.search, filter.retail_state, filter.retail_district, pagew, rowsPerPagew]);
  useEffect(() => {
    fetchStates(setState);
  }, []);

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Accordion sx={{ mb: 1 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography variant="h3">Branding Dashboard</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <StatCard
                icon={<BarChartIcon />}
                iconColor="#720E9E"
                bgColor="#6B298D"
                color="#fff"
                value={Number(NoWithBrand).toLocaleString('en-IN')}
                label="No of Branding completed"
                change="+8% from last Month"
                changeColor="#42A5F5"
                isFilled
                // sx={{ border: '1px solid #6B298D' }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <StatCard
                icon={<DescriptionIcon />}
                iconColor="#FFAB91"
                bgColor="#fff"
                color="#000"
                value="0"
                label="No of order completed"
                change="+5% from last month"
                changeColor="#42A5F5"
                sx={{ border: '1px solid #6B298D' }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <StatCard
                icon={<LocalOfferIcon />}
                iconColor="#A5D6A7"
                bgColor="#fff"
                color="#000"
                value={Number(NoWithoutBrand).toLocaleString('en-IN')}
                label="No of Delivery pending"
                change="+1.2% from last month"
                changeColor="#42A5F5"
                sx={{ border: '1px solid #6B298D' }}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Grid item xs={12}>
        <SubCard sx={{ width: '100%', overflowX: 'auto' }}>
          <Box
            sx={{
              width: '100%',
              borderRadius: '12px',
              backgroundColor: '#e0e0e0',
              display: 'flex'
              // p: '2px'
            }}
          >
            <Tabs
              value={value}
              onChange={handleTabChange}
              variant="fullWidth"
              TabIndicatorProps={{ style: { display: 'none' } }} // Remove default underline
              sx={{ width: '100%' }}
            >
              <Tab
                label="CSP With Branding"
                {...a11yProps(0)}
                sx={{
                  fontWeight: 600,
                  borderRadius: '10px',
                  textTransform: 'none',
                  backgroundColor: value === 0 ? '#5D217D' : 'transparent',
                  color: value === 0 ? '#fff' : '#6b6b6b',
                  // mx: 0.5,
                  transition: 'all 0.3s ease',
                  '&.Mui-selected': {
                    color: 'white !important' // ✅ Force white text when selected
                  }
                }}
              />
              <Tab
                label="CSP Without Branding"
                {...a11yProps(1)}
                sx={{
                  fontWeight: 600,
                  borderRadius: '10px',
                  textTransform: 'none',
                  backgroundColor: value === 1 ? '#5D217D' : 'transparent',
                  color: value === 1 ? '#fff' : '#6b6b6b',
                  // mx: 0.5,
                  transition: 'all 0.3s ease',
                  '&.Mui-selected': {
                    color: 'white !important' // ✅ Force white text when selected
                  }
                }}
              />
            </Tabs>
          </Box>

          {/* Search Filter */}
          <Box
            sx={{
              px: 1,
              py: 2,
              border: '1px solid #ccc',
              borderRadius: 2,
              mx: 1,
              my: 1
            }}
          >
            <SearchFilter State={State} filter={filter} handleChange={handleChange} handleClear={handleClear} />
          </Box>
          {/* Tab Panels */}
          <Box sx={{ px: 2, pb: 2 }}>
            <CustomTabPanel value={value} index={0}>
              <WithCsp
                refunctionwith={refunctionwith}
                CspBrand={CspBrand}
                TotalCount={TotalCount}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <WithoutCsp
                refunctionwithOut={refunctionwithOut}
                WithouCspBrand={WithouCspBrand}
                TotalCount={TotalCountw}
                setPage={setPagew}
                setRowsPerPage={setRowsPerPagew}
              />
            </CustomTabPanel>
          </Box>
        </SubCard>
      </Grid>
    </>
  );
};

export default Index;
